import { IScaffoldActionRowLeaveComplete, ScaffoldState } from "./interface";

/**
 * Handles the ROW_LEAVE_COMPLETE action by removing the specified row from
 * the leavingRows list once its exit animation has finished.
 *
 * @param action - The ROW_LEAVE_COMPLETE action carrying the id of the row that finished animating out.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the completed leaving row removed from leavingRows.
 */
export const scr_rowLeaveComplete = <T>(
  action: IScaffoldActionRowLeaveComplete,
  state: ScaffoldState<T>,
): ScaffoldState<T> => ({
  ...state,
  leavingRows: state.leavingRows.filter((r) => r.id !== action.rowId),
});
